import { FC } from "react"
import './proveedoressalidaskpi.css'
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io"
import { numberFormatter } from "../../../../../utils/helperFunctions"

export const ProveedoresSalidasKPI:FC<any> = (props):JSX.Element => {

    const { title, valueA, valueB, comparativa,transporte,filtered, tabID} = props

    if(comparativa) {
        return(
            <div className="proveedoressalidas-kpi-wrapper-comp" >
                <span >
                    <span style={
                        transporte? 
                            
                        {color:'var(--lis-dark)',fontSize:'1.5rem'}
                        : 
                            
                        {color:'var(--lis-dark)'}
                        
                        }>{ numberFormatter(valueA ?? 0)  } {valueA > valueB ? <IoMdArrowDropup style={{color:'green',minWidth:20}} size={16} /> : valueB > valueA? <IoMdArrowDropdown style={{color:'red',minWidth:20}} size={16} /> : <span style={{color:'gray'}}>-</span>} </span> 
                    <span style={transporte? {fontSize:'2rem'} : {}}>|</span>   
                     <span style={
                        transporte? 
                            
                                {color:'var(--lis-alternative)',fontSize:'1.5rem'}
                        : 
                            

                            {color:'var(--lis-alternative)'}
                        
                        }> { numberFormatter(valueB ?? 0) } {valueA < valueB ? <IoMdArrowDropup style={{color:'green',minWidth:20}} size={16} /> : valueB < valueA? <IoMdArrowDropdown style={{color:'red',minWidth:20}} size={16} /> : <span style={{color:'gray'}}>-</span>}</span>
                     </span>
                <span >{ title } {filtered && ((tabID === 3 && (title === 'Peso Neto (Tm)' || title === 'Coste Compra (€)')) || (tabID === 4 && (title === 'Peso Contratado (Tm)')) || tabID === 5) ? <span style={{color:'red'}}>**</span> : false}</span>
            </div>
        )
    } else {
        return (
            <div className="proveedoressalidas-kpi-wrapper" >
                <span style={
                    transporte?
                        
                            {color:'var(--lis-dark)',fontSize:'1.5rem'}
                        :
                        
                            {color:'var(--lis-dark)'}
                        }>
                            { numberFormatter(valueA ?? 0) }
                            </span>
                <span >{ title } {filtered && ((tabID === 3 && (title === 'Peso Neto (Tm)' || title === 'Coste Compra (€)')) || (tabID === 4 && (title === 'Peso Contratado (Tm)')) || tabID === 5) ? <span style={{color:'red'}}>**</span> : false}</span>
            </div>
        )
    }
}